import React from 'react';

// 30-color palette for account name cell coloring (light + vivid tones)
export const ACCOUNT_COLORS = [
  '#fecaca', '#fed7aa', '#fde68a', '#d9f99d', '#bbf7d0', '#a7f3d0', '#99f6e4', '#a5f3fc',
  '#bae6fd', '#bfdbfe', '#c7d2fe', '#ddd6fe', '#e9d5ff', '#f5d0fe', '#fbcfe8', '#fecdd3',
  '#ef4444', '#f97316', '#eab308', '#84cc16', '#22c55e', '#10b981', '#14b8a6', '#06b6d4',
  '#3b82f6', '#6366f1', '#8b5cf6', '#a855f7', '#d946ef', '#ec4899'
];

export const AccountColorPicker = ({ value, onChange }) => (
  <div className="flex flex-wrap gap-1.5" data-testid="account-color-picker">
    <button
      type="button"
      onClick={() => onChange('')}
      title="Tidak ada warna"
      data-testid="color-none"
      className={`h-6 w-6 rounded border border-slate-300 flex items-center justify-center bg-white ${!value ? 'ring-2 ring-offset-1 ring-teal-500' : ''}`}
    >
      <span className="text-[10px] text-slate-400">✕</span>
    </button>
    {ACCOUNT_COLORS.map((c) => (
      <button
        key={c}
        type="button"
        onClick={() => onChange(c)}
        title={c}
        data-testid={`color-${c}`}
        className={`h-6 w-6 rounded border border-slate-300 ${value === c ? 'ring-2 ring-offset-1 ring-teal-500' : ''}`}
        style={{ backgroundColor: c }}
      />
    ))}
  </div>
);

export default AccountColorPicker;
